<template>
    <div>
      <template v-for="(item, index) in anchorList">
        <li :key="index" class="box-item">
          <span
            v-if="!options.noteEditorAnchor && !options.fullScrollAnchor"
            class="mover icondrag icon-portal-drag"
            :class="dragging ? 'dragging' : ''"
          ></span>
          <div
            :class="options.noteEditorAnchor || options.fullScrollAnchor ? 'title-name hidden' : 'title-name'"
            :style="contenStyle"
            @click="editAnchor(path !== '' ? `${path}_${index}` : `${index}`)"
          >
            {{ item.content }}
          </div>
          <div v-if="options.noteEditorAnchor" class="del-btn" @click="copyAnchorAdress(item)">
            <span class="icon-portal-icon_copy-link"></span>
          </div>
          <div v-if="!options.noteEditorAnchor && !options.fullScrollAnchor" class="del-btn" @click="addSubAnchor(item)">
            <span class="icon-portal-plus-small"></span>
          </div>
          <div v-if="!options.noteEditorAnchor && !options.fullScrollAnchor" class="del-btn" @click="deleteAnchor(index)">
            <span class="icon-portal-minus"></span>
          </div>
          <div v-if="options.noteEditorAnchor || options.fullScrollAnchor" class="del-btn" @click="hideAnchor(item)">
            <span :class="item.hide ? 'icon-portal-preview-close-one1' : 'icon-portal-preview-open11'"></span>
          </div>
        </li>
        <anchor-option
          v-if="item.children && item.children.length > 0"
          :key="'child_' + index"
          :options="options"
          :anchorList="item.children"
          :level="level + 1"
          :path="path !== '' ? `${path}_${index}` : `${index}`"
          @update="updateView"
          @edit="editOption"
        />
      </template>
    </div>
  </template>

  <script>
  import { replaceUrlParam, copyTextToClipboard } from "@/utils"

  export default {
    name: "anchor-option",
    props: {
      options: Object,
      anchorList: Array,
      dragging: Boolean,
      level: {
        type: Number,
        default: 1
      },
      path: {
        type: String,
        default: ""
      }
    },
    computed: {
      contenStyle() {
        return {
          marginLeft: `${(this.level - 1) * 16 + (this.options.noteEditorAnchor || this.options.fullScrollAnchor ? 13 : 0)}px`
        }
      }
    },
    methods: {
      editAnchor(path) {
        if (this.options.noteEditorAnchor || this.options.fullScrollAnchor) {
          return
        }
        this.$emit("edit", path)
      },
      addSubAnchor(item) {
        item.children.push({ content: "子锚点", target: null, hide: false, children: [] })
        this.$emit("update")
      },
      deleteAnchor(index) {
        this.anchorList.splice(index, 1)
        this.$emit("update")
      },
      hideAnchor(item) {
        item.hide = !item.hide
        this.$emit("update")
      },
      updateView() {
        this.$emit("update")
      },
      editOption(path) {
        this.$emit("edit", path)
      },
      copyAnchorAdress(item) {
        this.$store.commit("states/changeCopyLinkStatus", true)
        document.querySelector(".previewSave .previewBtn").click()
        this.copyingTarget = item.target
        this.$eventBus.$on("after-copyLick-generate", this.generateCopyLink)
      },
      generateCopyLink(link) {
        let copyLink = replaceUrlParam(link, "noteTarget", this.copyingTarget)
        this.$eventBus.$off("after-copyLick-generate", this.generateCopyLink)
        // 避免接口返回不同协议类型，还要重定向
        copyLink = copyLink.replace(/(http|https):/, "")
        const result = copyLink.startsWith("//") ? `${location.protocol}${copyLink}` : `${location.origin}${copyLink}`
        copyTextToClipboard(result)
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "success",
          message: "链接已复制到剪切板"
        })
      }
    }
  }
  </script>

  <style lang="scss" scoped>
  .box-item {
    display: flex;
    align-items: center;
    height: 28px;
    margin-bottom: 8px;
    margin-left: -13px;
    // &:hover {
    //   .icondrag {
    //     visibility: visible;
    //   }
    // }
    .icondrag {
      visibility: hidden;
      color: rgba(0, 0, 0, 0.6);
      font-size: 10px;
      margin-right: 3px;
      &:not(.disabled):hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .title-name {
      width: 202px;
      height: 100%;
      background: rgba(243, 243, 243, 1);
      font-size: 13px;
      font-weight: 400;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.8);
      padding: 0 6px;
      border-radius: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      flex: 1;
      cursor: pointer;
      &.hidden {
        margin-left: 13px;
      }
      &:hover {
        background: rgba(233, 233, 233, 1);
      }
    }
    .del-btn {
      display: flex;
      align-items: center;
      width: 24px;
      height: 24px;
      padding: 5px;
      font-size: 14px;
      margin-left: 2px;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
  </style>
